import React, { useEffect, useState } from "react";
import notification from "../assets/images/notification.png";
import admin from "../assets/images/admin.png";
import downArrow from "../assets/images/down-arrow.png";
import profile from "../assets/images/profile.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logout from "./Logout";
import { getEmail } from "../utils/getToken";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { viewProfile } from "../features/slices/authReducer";
const obj = {
  dashboard: "Welcome to Dashboard",
  student: "Student Management",
  category: "Category Management",
  courses: "Course Management",
  ["/challenges"]: "Challenges & Bounty Management",
  feed: "Feeds Management",
  livestream: "Livestream Management",
  notification: "Notification Management",
  payment: "Payment Management",
  podcast: "Podcast Management",
  subadmin: "Sub-Admin Management",
  staticContent: "Static Content Management",
  changePassword: "Change Password",
  studentDetails: "Details",
  topicDetails: "Topics",
  termsCondition: "Terms & Conditions",
  privacyPolicy: "Privacy Policy",
  profile: "Profile Management",
  ["/challenges/challengeAdd"]: "Challenges & Bounty Management",
  ["/challenges/editUpcoming"]: "Challenges & Bounty Management",
  ["/challenges/challengesDetails"]: "Challenges & Bounty Management",
  ["/challenges/addPrize"]: "Add New Prize",
  ["/challenges/listSubmission"]: "List of Submission",
  ["/challenges/liveSubmissionCompleted/completed"]: "List of Submission",
  ["/challenges/liveSubmissionCompleted/ongoing"]: "List of Submission",
  ["/challenges/leaderboardAddWinnerList"]: "Winner List",
  ["/challenges/viewPrizeDetails"]: "View Prize Details",
  ["/challenges/viewPrize"]: "Prize Details",
  ["/challenges/editPrize"]: "Edit Prize",
  ["/challenges/winnerListCompleted"]: "Winner List",
  ["/challenges/submissionDetail"]: "Answer details",
  ["/challenges/rankPointAdd"]: "Rank & Points",
};
const Header = () => {
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(viewProfile());
  }, [dispatch]);
  const type = search.split("=")[1];
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (
      pathname.includes("/challenges/rankPointAdd") ||
      pathname.includes("/challenges/liveSubmissionCompleted")
    ) {
      navigate("/challenges");
    } else {
      navigate(-1);
    }
  };
  const backButton = pathname.split("/")[2];
  let url;
  if (pathname.includes("challenges")) {
    url = pathname;
  } else {
    url = pathname.split("/")[1];
  }
  const [logoutModal, setLogout] = useState(false);
  const data = getEmail("adminLogin");
  const { profileData } = useSelector((state) => {
    return state?.auth;
  });
  return (
    <>
      <div className="Header">
        <div className="HeaderBox mt-2">
          <div className="HeaderLeft">
            {backButton && (
              <a onClick={handleNavigate}>
                <i className="fa fa-angle-left" />
              </a>
            )}
            <figcaption>
              <h3>{type ? "Student Management" : obj[url]}</h3>
              <p>
                {url == "dashboard"
                  ? "Track your manage and LMS platform performance"
                  : "Let’s check your update today"}
              </p>
            </figcaption>
          </div>
          <div className="Navigation">

            <div className="Avater">
              <a href="javascript:void(0);">
                <figure>
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    src={profileData?.activeUser?.profilePic || admin}
                  />
                </figure>
                <img src={downArrow} />
              </a>
              <ul
                style={{
                  paddingLeft: "0rem",
                }}
              >
                <li>
                  <figure>
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      src={profileData?.activeUser?.profilePic || admin}
                    />
                  </figure>
                  <h4>
                    {" "}
                    {profileData?.activeUser?.name}{" "}
                    <span>{profileData?.activeUser?.userType}</span>
                  </h4>
                </li>
                <li>
                  <Link to={"/profile"}>
                    <span>
                      <i className="fa-regular fa-user" />
                    </span>{" "}
                    Profile
                  </Link>
                </li>
                <li>
                  <Link to={"/changePassword"}>
                    <span>
                      <i className="fa-solid fa-gear" />
                    </span>{" "}
                    Change Password
                  </Link>
                </li>
                <li>
                  <a onClick={() => setLogout(true)}>
                    <span>
                      <i className="fa fa-sign-out" />
                    </span>{" "}
                    Logout
                  </a>
                </li>
              </ul>
            </div>
            <div className="clear" />
          </div>
        </div>
      </div>
      {logoutModal && <Logout setLogout={setLogout} />}
    </>
  );
};

export default Header;
